webpackJsonp([1],{

/***/ "+jyM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Spinner_vue__ = __webpack_require__("GH5M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d4e88a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Spinner_vue__ = __webpack_require__("mt7o");
function injectStyle (ssrContext) {
  __webpack_require__("Q1h1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Spinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d4e88a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Spinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/bMK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Picker_vue__ = __webpack_require__("rSlA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17f810eb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Picker_vue__ = __webpack_require__("AjtG");
function injectStyle (ssrContext) {
  __webpack_require__("7zv0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Picker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17f810eb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Picker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7zv0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AjtG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"picker"},[_c('div',{staticClass:"flex"},[(_vm.pickingBook)?_c('div',{attrs:{"id":"ot"}},[_c('h2',[_vm._v("Old")]),_vm._v(" "),_c('ul',_vm._l((_vm.books.slice(0, 39)),function(b,index){return _c('li',{staticClass:"choosable",class:{chosen: b === _vm.book}},[_c('a',{on:{"click":function($event){_vm.pick(b.abbr)}}},[_vm._v(_vm._s(index+1)+". "+_vm._s(b.name))])])}))]):_vm._e(),_vm._v(" "),(_vm.pickingBook)?_c('div',{attrs:{"id":"nt"}},[_c('h2',[_vm._v("New")]),_vm._v(" "),_c('ul',_vm._l((_vm.books.slice(39)),function(b,index){return _c('li',{staticClass:"choosable",class:{chosen: b === _vm.book}},[_c('a',{on:{"click":function($event){_vm.pick(b.abbr)}}},[_vm._v(_vm._s(index+40)+". "+_vm._s(b.name))])])}))]):_vm._e(),_vm._v(" "),(!_vm.pickingBook)?_c('div',{attrs:{"id":"chaps"}},[_c('div',{staticClass:"flex align-center"},[_c('h2',{staticClass:"flex-1"},[_vm._v(_vm._s(_vm.book.name))]),_vm._v(" "),_c('a',{staticClass:"align-end pager back",on:{"click":function($event){_vm.pickBookAgain()}}},[_vm._v("🔙")])]),_vm._v(" "),(_vm.fetchingChapters)?_c('spinner'):_vm._e(),_vm._v(" "),_c('ul',{staticClass:"flex wrap"},_vm._l((_vm.chapters),function(c){return _c('li',{staticClass:"chapter-choose"},[_c('a',{on:{"click":function($event){_vm.goto(c)}}},[_vm._v(_vm._s(c))])])}))],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AllU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'History',
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
    history: 'history'
  })),
  methods: {}
});

/***/ }),

/***/ "BMQ7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FS4H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Bible_vue__ = __webpack_require__("mKhU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_287c5626_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Bible_vue__ = __webpack_require__("agYh");
function injectStyle (ssrContext) {
  __webpack_require__("XqzY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-287c5626"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Bible_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_287c5626_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Bible_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GH5M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Spinner'
});

/***/ }),

/***/ "IHik":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_076a70a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("IHik");
function injectStyle (ssrContext) {
  __webpack_require__("Z2nz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_076a70a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("olkN");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "Q1h1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XqzY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Bible__ = __webpack_require__("FS4H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Picker__ = __webpack_require__("/bMK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_History__ = __webpack_require__("yZHR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__("olkN");








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },

  routes: [{
    path: '/',
    redirect: function redirect(to) {
      if (__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].state.book) {
        return { name: 'Bible', params: { book: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].state.book, chapter: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].state.chapter || 1 } };
      }
      return { name: 'Bible', params: { book: 'Gen', chapter: '1' } };
    }
  }, {
    path: '/bible/:book',
    redirect: function redirect(to) {
      return to.path + '/1';
    }
  }, {
    path: '/bible/:book/:chapter',
    name: 'Bible',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Bible__["a" /* default */]
  }, {
    path: '/picker',
    name: 'Picker',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Picker__["a" /* default */]
  }, {
    path: '/history',
    name: 'History',
    component: __WEBPACK_IMPORTED_MODULE_4__components_History__["a" /* default */]
  }]
}));

/***/ }),

/***/ "Z2nz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "agYh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bible"},[_c('transition',{attrs:{"name":"slide"}},[_c('header',{directives:[{name:"show",rawName:"v-show",value:(_vm.isHeaderVisible),expression:"isHeaderVisible"}]},[_c('nav',{staticClass:"flex align-center"},[(_vm.book)?_c('h2',{staticClass:"flex-1 pointer",on:{"click":function($event){_vm.picker()}}},[_vm._v("\n          "+_vm._s(_vm.book.name)+" "+_vm._s(_vm.chapter)+"\n        ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"align-end"},[_c('a',{staticClass:"pager",on:{"click":function($event){_vm.picker()}}},[_vm._v("📖")]),_vm._v(" "),_c('router-link',{staticClass:"pager",attrs:{"to":{name: 'History'}}},[_vm._v("📜")]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.chapter > 1),expression:"chapter > 1"}],staticClass:"pager",on:{"click":function($event){_vm.back()}}},[_vm._v("⬅️")]),_vm._v(" "),_c('a',{staticClass:"pager",on:{"click":function($event){_vm.next()}}},[_vm._v("➡️")])],1)])])]),_vm._v(" "),(_vm.error)?_c('aside',{staticClass:"flex"},[_c('span',{staticClass:"flex-1"},[_vm._v("Error: "+_vm._s(_vm.error))]),_vm._v(" "),_c('button',{staticClass:"align-end",on:{"click":function($event){_vm.dismiss()}}},[_vm._v("X")])]):_vm._e(),_vm._v(" "),_c('main',[(_vm.isLoadingVerses)?_c('spinner'):_vm._e(),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.verses)}}),_vm._v(" "),_c('span',{attrs:{"id":"main"}})],1),_vm._v(" "),_c('footer',[_c('p',{staticClass:"right"},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.chapter > 1),expression:"chapter > 1"}],staticClass:"pager",on:{"click":function($event){_vm.back()}}},[_vm._v("⬅️")]),_vm._v(" "),_c('a',{staticClass:"pager",on:{"click":function($event){_vm.next()}}},[_vm._v("➡️")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "loqM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"history"},[_c('div',{staticClass:"flex align-center"},[_c('h2',{staticClass:"flex-1"},[_vm._v("History")]),_vm._v(" "),_c('a',{staticClass:"align-end back pager",on:{"click":function($event){_vm.$router.go(-1)}}},[_vm._v("🔙")])]),_vm._v(" "),(_vm.history.length === 0)?_c('div',[_vm._v("\n    No history yet!\n  ")]):_c('div',[_c('ul',{staticClass:"right"},_vm._l((_vm.history),function(item){return _c('li',[_c('router-link',{attrs:{"to":{name: 'Bible', params: {book: item.book, chapter: item.chapter}}}},[_vm._v("\n          "+_vm._s(item.book)+" "+_vm._s(item.chapter)+"\n        ")])],1)}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mKhU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_bible__ = __webpack_require__("w0yu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Spinner__ = __webpack_require__("+jyM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Bible',
  data: function data() {
    return {
      verses: "",
      chapters: [],
      error: '',
      isLoadingVerses: true,
      isLoadingChapters: true,

      // scrolly stuff
      isHeaderVisible: true,
      scroller: null,
      didScroll: false,
      previousScrollPos: 0
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapState */])({
    book: function book(state) {
      return __WEBPACK_IMPORTED_MODULE_3__services_bible__["a" /* default */].books.find(function (b) {
        return b.abbr === state.book;
      });
    },
    chapter: 'chapter'
  })),
  watch: {
    '$route.params.book': function $routeParamsBook(newBook) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$store.commit('setBook', newBook);
                _this.isLoadingVerses = true;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_3__services_bible__["a" /* default */].fetchVerses(_this.book.abbr, _this.chapter);

              case 4:
                _this.verses = _context.sent;

                _this.isLoadingVerses = false;

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    '$route.params.chapter': function $routeParamsChapter(newChapter) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$store.commit('setChapter', newChapter);
                _this2.isLoadingVerses = true;
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_3__services_bible__["a" /* default */].fetchVerses(_this2.book.abbr, _this2.chapter);

              case 4:
                _this2.verses = _context2.sent;

                _this2.isLoadingVerses = false;

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this3.isLoadingVerses = true;
              _this3.isLoadingChapters = true;

              _this3.$store.commit('setBook', _this3.$route.params.book);

              if (!(_this3.book === undefined)) {
                _context3.next = 6;
                break;
              }

              _this3.error = 'Book not found';
              return _context3.abrupt('return');

            case 6:
              _this3.$store.commit('setChapter', _this3.$route.params.chapter);

              _context3.next = 9;
              return __WEBPACK_IMPORTED_MODULE_3__services_bible__["a" /* default */].fetchVerses(_this3.book.abbr, _this3.chapter);

            case 9:
              _this3.verses = _context3.sent;

              _this3.isLoadingVerses = false;

            case 11:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },

  methods: {
    dismiss: function dismiss() {
      this.error = '';
    },
    back: function back() {
      if (this.chapter === 1) {
        return;
      }
      this.$router.push({ name: 'Bible', params: { book: this.book.abbr, chapter: this.chapter - 1 } });
    },
    next: function next() {
      this.$router.push({ name: 'Bible', params: { book: this.book.abbr, chapter: this.chapter + 1 } });
    },
    picker: function picker() {
      this.$router.push({ name: 'Picker' });
    },
    handleScroll: function handleScroll() {
      this.didScroll = true;
    },
    hasScrolled: function hasScrolled() {
      var scrollPos = document.scrollingElement.scrollTop;
      if (scrollPos > this.previousScrollPos) {
        this.isHeaderVisible = false;
      } else if (scrollPos < this.previousScrollPos) {
        this.isHeaderVisible = true;
      }
      this.previousScrollPos = scrollPos;
    }
  },
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_4__Spinner__["a" /* default */]
  },
  created: function created() {
    var _this4 = this;

    window.addEventListener('scroll', this.handleScroll);
    this.scroller = setInterval(function () {
      if (_this4.didScroll) {
        _this4.hasScrolled();
        _this4.didScroll = false;
      }
    }, 100);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
    clearInterval(this.scroller);
  }
});

/***/ }),

/***/ "mt7o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner"},[_c('div',{staticClass:"bounce1"}),_vm._v(" "),_c('div',{staticClass:"bounce2"}),_vm._v(" "),_c('div',{staticClass:"bounce3"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "olkN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__ = __webpack_require__("UIay");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__);




__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* default */].Store({
  plugins: [__WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate___default()()],
  state: {
    book: 'Gen',
    chapter: 1,
    history: []
  },
  mutations: {
    setBook: function setBook(state, book) {
      state.book = book;
    },
    setChapter: function setChapter(state, chapter) {
      state.chapter = parseInt(chapter);

      // enter history entry
      var entry = { book: state.book, chapter: state.chapter };
      var found = false;
      for (var i = 0; i < state.history.length; i++) {
        var item = state.history[i];
        if (item.book === entry.book && item.chapter === entry.chapter) {
          found = true;
          state.history.splice(i, 1);
          state.history.unshift(entry);
        }
      }
      if (!found) {
        state.history.unshift(entry);
      }
    }
  }
}));

/***/ }),

/***/ "rSlA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_bible__ = __webpack_require__("w0yu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Spinner__ = __webpack_require__("+jyM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Picker',
  data: function data() {
    return {
      books: __WEBPACK_IMPORTED_MODULE_3__services_bible__["a" /* default */].books,
      chapters: [],
      pickingBook: true,
      fetchingChapters: false
    };
  },

  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_4__components_Spinner__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapState */])({
    book: function book(state) {
      return __WEBPACK_IMPORTED_MODULE_3__services_bible__["a" /* default */].books.find(function (b) {
        return b.abbr === state.book;
      });
    },
    chapter: 'chapter'
  })),
  mounted: function mounted() {
    this.pickingBook = true;
  },

  methods: {
    cancel: function cancel() {
      this.$router.go(-1);
    },
    pick: function pick(bookAbbr) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$store.commit('setBook', bookAbbr);
                _this.fetchingChapters = true;
                _this.pickingBook = false;
                _this.chapters = [];
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_3__services_bible__["a" /* default */].fetchChapters(bookAbbr);

              case 6:
                _this.chapters = _context.sent;

                _this.fetchingChapters = false;

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    goto: function goto(chapter) {
      this.$store.commit('setChapter', chapter);
      this.$router.replace({ name: 'Bible', params: { book: this.book.abbr, chapter: chapter } });
    },
    pickBookAgain: function pickBookAgain() {
      this.pickingBook = true;
    }
  }
});

/***/ }),

/***/ "w0yu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var fetchChapters = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(bookAbbr) {
    var chapters;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(chapterCache[bookAbbr] !== undefined)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt('return', chapterCache[bookAbbr]);

          case 2:
            _context.next = 4;
            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/versions/ESV/' + bookAbbr);

          case 4:
            chapters = _context.sent.data;

            chapterCache[bookAbbr] = chapters;
            return _context.abrupt('return', chapters);

          case 7:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function fetchChapters(_x) {
    return _ref.apply(this, arguments);
  };
}();

var fetchVerses = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(bookAbbr, chapter) {
    var key, verses;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            key = bookAbbr + chapter;

            if (!(verseCache[key] !== undefined)) {
              _context2.next = 3;
              break;
            }

            return _context2.abrupt('return', verseCache[key]);

          case 3:
            _context2.next = 5;
            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/versions/ESV/' + bookAbbr + '/' + chapter);

          case 5:
            verses = _context2.sent.data;

            verseCache[key] = verses;
            return _context2.abrupt('return', verses);

          case 8:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function fetchVerses(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();



var books = [{ abbr: 'Gen', name: 'Genesis' }, { abbr: 'Exod', name: 'Exodus' }, { abbr: 'Lev', name: 'Leviticus' }, { abbr: 'Num', name: 'Numbers' }, { abbr: 'Deut', name: 'Deuteronomy' }, { abbr: 'Josh', name: 'Joshua' }, { abbr: 'Judg', name: 'Judges' }, { abbr: 'Ruth', name: 'Ruth' }, { abbr: '1Sam', name: '1 Samuel' }, { abbr: '2Sam', name: '2 Samuel' }, { abbr: '1Kgs', name: '1 Kings' }, { abbr: '2Kgs', name: '2 Kings' }, { abbr: '1Chr', name: '1 Chronicles' }, { abbr: '2Chr', name: '2 Chronicles' }, { abbr: 'Ezra', name: 'Ezra' }, { abbr: 'Neh', name: 'Nehemiah' }, { abbr: 'Esth', name: 'Esther' }, { abbr: 'Job', name: 'Job' }, { abbr: 'Ps', name: 'Psalm' }, { abbr: 'Prov', name: 'Proverbs' }, { abbr: 'Eccl', name: 'Ecclesiastes' }, { abbr: 'Song', name: 'Song of Solomon' }, { abbr: 'Isa', name: 'Isaiah' }, { abbr: 'Jer', name: 'Jeremiah' }, { abbr: 'Lam', name: 'Lamentations' }, { abbr: 'Ezek', name: 'Ezekiel' }, { abbr: 'Dan', name: 'Daniel' }, { abbr: 'Hos', name: 'Hosea' }, { abbr: 'Joel', name: 'Joel' }, { abbr: 'Amos', name: 'Amos' }, { abbr: 'Obad', name: 'Obadiah' }, { abbr: 'Jonah', name: 'Jonah' }, { abbr: 'Mic', name: 'Micah' }, { abbr: 'Nah', name: 'Nahum' }, { abbr: 'Hab', name: 'Habakkuk' }, { abbr: 'Zeph', name: 'Zephaniah' }, { abbr: 'Hag', name: 'Haggai' }, { abbr: 'Zech', name: 'Zechariah' }, { abbr: 'Mal', name: 'Malachi' }, { abbr: 'Matt', name: 'Matthew' }, { abbr: 'Mark', name: 'Mark' }, { abbr: 'Luke', name: 'Luke' }, { abbr: 'John', name: 'John' }, { abbr: 'Acts', name: 'Acts' }, { abbr: 'Rom', name: 'Romans' }, { abbr: '1Cor', name: '1 Corinthians' }, { abbr: '2Cor', name: '2 Corinthians' }, { abbr: 'Gal', name: 'Galatians' }, { abbr: 'Eph', name: 'Ephesians' }, { abbr: 'Phil', name: 'Philippians' }, { abbr: 'Col', name: 'Colossians' }, { abbr: '1Thess', name: '1 Thessalonians' }, { abbr: '2Thess', name: '2 Thessalonians' }, { abbr: '1Tim', name: '1 Timothy' }, { abbr: '2Tim', name: '2 Timothy' }, { abbr: 'Titus', name: 'Titus' }, { abbr: 'Phlm', name: 'Philemon' }, { abbr: 'Heb', name: 'Hebrews' }, { abbr: 'Jas', name: 'James' }, { abbr: '1Pet', name: '1 Peter' }, { abbr: '2Pet', name: '2 Peter' }, { abbr: '1John', name: '1 John' }, { abbr: '2John', name: '2 John' }, { abbr: '3John', name: '3 John' }, { abbr: 'Jude', name: 'Jude' }, { abbr: 'Rev', name: 'Revelation' }];

var chapterCache = {};

var verseCache = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  books: books,

  fetchChapters: fetchChapters,
  fetchVerses: fetchVerses
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ "yZHR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_History_vue__ = __webpack_require__("AllU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54e9682a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_History_vue__ = __webpack_require__("loqM");
function injectStyle (ssrContext) {
  __webpack_require__("BMQ7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_History_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54e9682a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_History_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.d552195fa5c0cf5f7e47.js